import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ProximityEditComponent, type ProximityEditProps,
} from './proximityEdit.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ProximityEdit: ProximityEditProps;
  }
}

modalRenderer.register('ProximityEdit', ProximityEditComponent);
